/**
 * GLDN Beam Drawer Re-hydrate
 *
 * The Beam <beam-select-nonprofit> web component initializes on page
 * load. When it lives inside the cart drawer dialog (which is hidden
 * with display:none until opened), the SDK's first render runs against
 * the hidden tree and may skip painting the "selected nonprofit" card
 * portion of the widget. Cart attribute persists correctly
 * (nonprofit_id stays set), but the visible UI shows only the icon
 * picker without the selection card.
 *
 * On every dialog:open event for the cart drawer, detach and re-attach
 * each <beam-select-nonprofit> inside the drawer. The SDK's
 * disconnectedCallback + connectedCallback fire, the component re-reads
 * cart attributes, and the selected state renders correctly.
 *
 * Cart page widget (in main-cart section, not in a dialog) is
 * untouched — it renders correctly on first paint already.
 */
(function () {
  function rehydrateBeamIn(scope) {
    if (!scope) return;
    var widgets = scope.querySelectorAll('beam-select-nonprofit');
    widgets.forEach(function (w) {
      var parent = w.parentNode;
      if (!parent) return;
      var next = w.nextSibling;
      // Detach + re-attach to force connectedCallback to fire again.
      parent.removeChild(w);
      // Yield a frame so the SDK's disconnect handlers settle, then
      // reinsert at the same position.
      requestAnimationFrame(function () {
        parent.insertBefore(w, next);
      });
    });
  }

  /* Did the widget actually render the selected-nonprofit card? The SDK
   * paints children (text + progress bar) into the <beam-select-nonprofit>
   * subtree once it's read the cart attribute. If the widget is still
   * "empty" (icon-picker only with no children rendered inside the
   * web component), the rehydrate is worth another retry. */
  function widgetLooksHydrated(widget) {
    if (!widget) return false;
    // Widgets that have read cart state and have a selection painted
    // typically have non-empty inner content (the selected-nonprofit
    // card + progress bar). Empty/un-hydrated widgets are bare custom
    // elements with no internal markup yet.
    var inner = (widget.textContent || '').trim();
    return inner.length > 0;
  }

  function rehydrateWithRetries(scope) {
    /* The SDK's initialization may race the dialog:open timing. Try
     * several times so we cover the cases where:
     * - SDK is fully ready: first call finishes the job
     * - SDK still loading: later calls catch up once it's done
     * Stop retrying as soon as the widget looks hydrated. */
    var delays = [100, 400, 900, 1800];
    delays.forEach(function (ms) {
      setTimeout(function () {
        var widgets = scope.querySelectorAll('beam-select-nonprofit');
        var anyUnhydrated = false;
        widgets.forEach(function (w) {
          if (!widgetLooksHydrated(w)) anyUnhydrated = true;
        });
        if (anyUnhydrated) rehydrateBeamIn(scope);
      }, ms);
    });
  }

  document.addEventListener('dialog:open', function (e) {
    var dialog = e.target && (e.target.closest && e.target.closest('cart-drawer-component'));
    if (!dialog) return;
    rehydrateWithRetries(dialog);
  });

  /* Also rehydrate after cart updates inside the drawer — Horizon's
   * morphSection may rewrite the widget's surroundings and leave it
   * in a stale render state. */
  document.addEventListener('cart:update', function () {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Only act if the drawer is open; closed drawers will hydrate on
    // their own dialog:open path.
    var dialog = drawer.querySelector('dialog[open]');
    if (!dialog) return;
    rehydrateWithRetries(drawer);
  });
})();
